import { isTruthy, toEnum } from '../typing.js';
import { Carrier, CarrierService } from './merchant/schema/storeShipRate.js';
/**
 * the default carriers supported by the Corso platform
 */
export const CorsoDefaultCarrier = {
    [Carrier.USPS]: Carrier.USPS,
    [Carrier.UPSDAP]: Carrier.UPSDAP,
    [Carrier.FedExDefault]: Carrier.FedExDefault,
};
const separateCarrierService = (carrierService) => {
    const match = carrierService?.match(new RegExp(`^(?<carrier>${Object.values(Carrier).join('|')})_(?<service>.*)$`));
    return {
        carrier: match?.groups?.carrier
            ? toEnum(match.groups.carrier, Carrier)
            : null,
        service: match?.groups?.service ?? null,
    };
};
const extractService = (carrierRate) => separateCarrierService(carrierRate).service;
const extractCarrier = (carrierRate) => separateCarrierService(carrierRate).carrier;
const isUsps = (carrierService) => extractCarrier(carrierService) === Carrier.USPS;
/**
 * get the services for the given carrier
 */
function extractServicesFromCarriers(c) {
    return Object.values(CarrierService)
        .filter((carrierService) => {
        const { carrier } = separateCarrierService(carrierService);
        if (!carrier)
            return null;
        return carrier === c;
    })
        .filter(isTruthy);
}
export const carrierServiceUtils = {
    extractService,
    extractCarrier,
    isUsps,
    extractServicesFromCarriers,
    separateCarrierService,
};
//# sourceMappingURL=carrierServiceUtils.js.map